import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class TopLocationService {
  private _waitRedirect = false;
  private _isRedirecting = false;
  private _deprecatedIsRedirecting = false;

  public get isRedirecting(): boolean {
    return this._isRedirecting || this._deprecatedIsRedirecting;
  }

  /** @deprecated remove this we should not set redirecting from outside */
  public set isRedirecting(value: boolean) {
    this._deprecatedIsRedirecting = value;
  }

  set href(href: string) {
    if (this._isRedirecting) {
      return;
    }
    this._isRedirecting = true;
    try {
      window.top.location.href = href;
    } catch (err) {
      // a fallback option in case the redirect for the example in the iframe is unavailable
      window.open(href, '_blank');
    }
  }

  get href(): string {
    return window.top.location.href;
  }

  set waitRedirect(value: boolean) {
    this._waitRedirect = value;
  }

  get waitRedirect(): boolean {
    return this._waitRedirect;
  }

}
